export default "__VITE_ASSET__dad49b87__"